import React, { useState, useEffect } from 'react'
import { Panel, Row, Col, Icon, IconButton, Button, Table, Message } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../../utils/loading'
import InfoAssetRegisterReport from '../assetRegisterReportWidgets/InfoAssetRegisterReport'
import { useHistory } from 'react-router-dom'
import pathname from '../../../constants/pathname'
import PdfRenderWidgets from '../../pdfWidgets/PdfRenderWidgets'
import {
  isImageOrPdf,
  isRequired,
  isValidators,
  requiredFiled,
  getMaxLengthData,
} from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import MiniProjectInfo from '../../projectBasedItemsWidget/MiniProjectInfo'
import PreviewButton from '../../../components/buttons/previewButton/PreviewButton'
import {
  exportAssetprojectstatus,
  searchAssetprojectstatus,
} from '../../../redux/actions/addDurableArticles'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import { downloadFile } from '../../../utils/fileUtil'

export default function AssetStatusReportWidget(props) {
  const { Column, HeaderCell, Cell, Pagination } = Table

  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [dataTable, setDataTable] = useState()
  const [isExpanded, setIsExpanded] = useState(true)
  const history = useHistory()
  const [errorMsg, setErrorMsg] = useState()

  const fs = localStorage.getItem('fontSize')

  const onPreview = async () => {
    console.log('onPreview')

    setIsLoading(true)
    startLoading()
    try {
      const _schema = await searchAssetprojectstatus()
      // console.log('schema => ', _schema.model.values)
      setDataTable(_schema.model.values)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const exportToExcel = async () => {
    console.log('exportToExcel')

    setIsLoading(true)
    startLoading()
    setIsError(false)
    try {
      const file = await exportAssetprojectstatus()

      if (file) {
        downloadFile(file, file.name || `รายงานแสดงสถานะครุภัณฑ์โครงการ`)
      } else {
        handelSetErrorMsg('error')
      }
    } catch (e) {
      // let errorJson = JSON.parse(await e.response.data.text())
      setIsError(true)
      // handelSetErrorMsg('error', errorJson?.errors?.message)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handelSetErrorMsg = (type, description) => {
    let desc = description ? description : `ไม่สามารถทำรายการได้ กรุณาลองใหม่หรือติดต่อผู้ดูแลระบบ`
    setErrorMsg({ type, description: desc })
    setTimeout(() => setErrorMsg(null), 5000)
  }

  return (
    <>
      <Panel
        shaded
        collapsible
        defaultExpanded
        header={''}
        bordered
        expanded={isExpanded}
        onSelect={() => {
          setIsExpanded(!isExpanded)
        }}
      >
        {isLoading && !isError && <OverlayLoader />}

        {/* <MiniProjectInfo schema={formSchema?.projectInfo} /> */}

        <Row style={{ marginTop: 30 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}></Col>
          <Col lg={20} md={20} sm={24} xs={24}>
            <PreviewButton onClick={onPreview} />

            <IconButton
              appearance="ghost"
              icon={<Icon icon="file-excel-o" className="bt-gost-icon-radius" />}
              onClick={exportToExcel}
              style={{ marginLeft: 5, marginTop: -10 }}
            >
              Export to Excel
            </IconButton>
          </Col>
        </Row>

        {errorMsg && (
          <Message
            showIcon
            type={errorMsg.type}
            description={errorMsg.description}
            style={{ marginBottom: 20 }}
          />
        )}

        {dataTable && (
          <>
            <Row style={{ marginTop: 5 }}>
              <Table
                isTree
                defaultExpandAllRows
                rowKey="id"
                height={800}
                // headerHeight={fs > 16 ? 80 : 40}
                data={dataTable}
                // onExpandChange={(isOpen, rowData) => {
                //   console.log(isOpen, rowData)
                // }}
                renderTreeToggle={(icon, rowData) => {
                  if (rowData.children && rowData.children.length === 0) {
                    return ''
                    // return <Icon icon="minus" />
                  }
                  return icon
                }}
              >
                <Column flexGrow={1}>
                  <HeaderCell style={{ textAlign: 'center' }}>สำนัก</HeaderCell>
                  <Cell>
                    {(rowData) => {
                      if (rowData.isRowMaster) {
                        return <b style={{ color: '#2da888' }}>{rowData.departmentName}</b>
                      }

                      if (rowData.isTotal) {
                        return <b>{rowData.departmentName}</b>
                      }

                      return rowData.departmentName
                    }}
                  </Cell>
                </Column>

                <Column width={100}>
                  <HeaderCell style={{ textAlign: 'center' }}>ขาย</HeaderCell>
                  <Cell style={{ textAlign: 'center' }}>
                    {(rowData) => {
                      if (rowData.isRowMaster) {
                        return <b style={{ color: '#2da888' }}>{rowData.selled}</b>
                      }

                      if (rowData.isTotal) {
                        return <b>{rowData.selled}</b>
                      }

                      return rowData.selled
                    }}
                  </Cell>
                </Column>

                <Column width={180}>
                  <HeaderCell style={{ textAlign: 'center' }}>โอนระหว่างโครงการ</HeaderCell>
                  <Cell style={{ textAlign: 'center' }}>
                    {(rowData) => {
                      if (rowData.isRowMaster) {
                        return <b style={{ color: '#2da888' }}>{rowData.transferToProject}</b>
                      }

                      return rowData.transferToProject
                    }}
                  </Cell>
                </Column>

                <Column width={100}>
                  <HeaderCell style={{ textAlign: 'center' }}>บริจาค</HeaderCell>
                  <Cell style={{ textAlign: 'center' }}>
                    {(rowData) => {
                      if (rowData.isRowMaster) {
                        return <b style={{ color: '#2da888' }}>{rowData.donate}</b>
                      }

                      return rowData.donate
                    }}
                  </Cell>
                </Column>

                <Column width={100}>
                  <HeaderCell style={{ textAlign: 'center' }}>ส่งคืน สสส.</HeaderCell>
                  <Cell style={{ textAlign: 'center' }}>
                    {(rowData) => {
                      if (rowData.isRowMaster) {
                        return <b style={{ color: '#2da888' }}>{rowData.returnSso}</b>
                      }

                      return rowData.returnSso
                    }}
                  </Cell>
                </Column>

                <Column width={150}>
                  <HeaderCell style={{ textAlign: 'center' }}>ใช้ในโครงการ</HeaderCell>
                  {/* <Cell dataKey="usedProject" style={{ textAlign: 'right' }} /> */}
                  <Cell style={{ textAlign: 'center' }}>
                    {(rowData) => {
                      if (rowData.isRowMaster) {
                        return <b style={{ color: '#2da888' }}>{rowData.usedProject}</b>
                      }

                      return rowData.usedProject
                    }}
                  </Cell>
                </Column>
              </Table>
            </Row>
          </>
        )}
      </Panel>
    </>
  )
}
